__turbopack_context__.v({
  "container": "_2dOgQq_container",
  "content": "_2dOgQq_content",
  "created": "_2dOgQq_created",
  "read": "_2dOgQq_read",
  "rowContent": "_2dOgQq_rowContent",
  "slideInAnimation": "_2dOgQq_slideInAnimation",
});
